import React, { Component } from 'react'
import Slider from 'react-slick'
import Product from './Product'

/**
 * ProductCarousel — horizontal scrollable product slider.
 *
 * Uses react-slick (already a project dependency).
 * Responsive: shows `productsNumber` columns on desktop, 2 on tablet, 1 on mobile.
 *
 * Props:
 *  - products      {Array}   List of campaign product objects
 *  - campaign      {Object}  Current campaign
 *  - productsNumber {Number} Max slides visible at the widest breakpoint (default 4)
 *  - title         {string}  Section heading
 *  - lineColor     {string}  Accent underline colour (CSS colour string)
 *  - catalog       {bool}    If true: centred heading, hide the decorative icon
 */
class ProductCarousel extends Component {
  static defaultProps = {
    productsNumber: 4,
    lineColor: 'var(--color-primary, #82D643)',
    catalog: false,
  }

  getSettings() {
    const { productsNumber, products } = this.props
    const responsive = [
      { breakpoint: 1240, settings: { slidesToShow: Math.min(productsNumber, 3) } },
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640,  settings: { slidesToShow: 1 } },
    ]
    const enough = products.length >= productsNumber
    return {
      infinite: enough,
      speed: 500,
      slidesToShow: productsNumber,
      slidesToScroll: 1,
      responsive,
    }
  }

  render() {
    const { products, campaign, title, lineColor, catalog } = this.props

    return (
      <div className="gl-product-carousel bg-white soft-round">
        {/* Heading */}
        <div className="gl-product-carousel__header text-color pb-1 px-0">
          <h2 className={`pt-5 uppercase gl-product-carousel__title ${catalog ? 'text-center mb-2' : 'pl-6 text-left'}`}>
            {title}
          </h2>
        </div>

        {/* Accent line */}
        <div className={`mb-4 flex pl-6 ${catalog ? 'justify-center' : ''}`}>
          <span className="gl-product-carousel__line" style={{ backgroundColor: lineColor }} />
        </div>

        {/* Slider */}
        {products.length > 0
          ? (
            <div className="gl-product-carousel__track p-5">
              <Slider {...this.getSettings()}>
                {products.map((item, i) => (
                  <div className="gl-product-carousel__slide" key={i}>
                    {item.is_new && (
                      <div className="gl-product-carousel__new-badge primary-bg navbar-text text-sm px-2 py-1 inline-block rounded mb-1">
                        Novo
                      </div>
                    )}
                    <Product campaign={campaign} item={item} />
                  </div>
                ))}
              </Slider>
            </div>
          )
          : (
            <div className="text-center py-8 text-color font-quicksand-light">
              Sem produtos
            </div>
          )
        }
      </div>
    )
  }
}

export default ProductCarousel
